// HKDSE 2020 Paper 1 Knowledge Graph Samples - Complete Combined Set
// Merged from hkdse2020Samples_complete.js and hkdse2020Samples_complete_part2.js

import { hkdse2020Samples_complete } from './hkdse2020Samples_complete.js';
import { hkdse2020Samples_complete_part2 } from './hkdse2020Samples_complete_part2.js';

export const hkdse2020Samples_complete_combined = {
  ...hkdse2020Samples_complete,
  ...hkdse2020Samples_complete_part2
};

export { hkdse2020Samples_complete, hkdse2020Samples_complete_part2 }; 